export const stateName = 'conversation';
export let HarassmentWarningVariant;

(function (HarassmentWarningVariant) {
  HarassmentWarningVariant["Off"] = "off";
  HarassmentWarningVariant["Soft"] = "a";
  HarassmentWarningVariant["Hard"] = "b";
})(HarassmentWarningVariant || (HarassmentWarningVariant = {}));